<template>

  <div class="buttons-container">

    <!-- EDIT -->
    <div class="button">
      <v-icon class="mr-1" title="Edit" @click="edit(index)">mdi-pencil</v-icon>
    </div>

    <!-- DELETE -->
    <div class="button">
      <ProxyDeleteButton @click="del(item)"></ProxyDeleteButton>
    </div>

    <!-- MORE OPTIONS -->
    <div class="button">
      <v-menu
        offset-y
        v-model="showMoreOptions"
        :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click.stop="toggleMenu">
            mdi-dots-horizontal
          </v-icon>
        </template>

        <v-card>
          <v-card-text class="pa-0">
            <div class="option" @click.stop="suspend(item)">
              <v-icon class="align-center">mdi-cancel</v-icon>
              <p class="mb-0 align-center">Suspend all videos</p>
            </div>

            <div class="option" @click.stop="unsuspend(item)">
              <v-icon class="align-center">mdi-check</v-icon>
              <p class="mb-0 align-center">Unsuspend all videos</p>
            </div>

            <div class="option" @click.stop="reprocess(item)">
              <v-icon class="align-center">mdi-film</v-icon>
              <p class="mb-0 align-center">Reprocess videos</p>
            </div>

            <div class="option" @click="openTransfer(item)">
              <v-icon class="align-center">mdi-transfer</v-icon>
              <p class="mb-0 align-center">Transfer videos to another match</p>
            </div>

            <div class="option" @click="openPrivatization(item)">
              <v-icon class="align-center">mdi-incognito</v-icon>
              <p class="mb-0 align-center">Make videos private</p>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>

    <!-- MAKE VIDEOS PRIVATE -->
    <v-dialog v-model="privatizationToggled"
              :persistent="true"
              max-width="700px">
      <v-card>
        <v-card-text>
          <p class="dialog-text mb-5">Make videos private</p>

          <v-flex class="match-id">
            <AuthorSelector label="Choose one or more authors" :authors="item.authors" v-model="authorsToPrivatize"></AuthorSelector>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="cancelPrivatization">Cancel</v-btn>
            <v-btn color="primary"
                   @click.native="privatize">Go</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- TRANSFER VIDEOS TO ANOTHER MATCH -->

    <v-dialog v-model="transferToggled"
              :persistent="true"
              max-width="700px">
      <v-card>
        <v-card-text>
          <p class="dialog-text mb-5">Transfer videos to another match</p>

          <v-flex class="match-id">
            <AuthorSelector label="Choose one or more authors" :authors="item.authors" v-model="authorsToTransfer"></AuthorSelector>
          </v-flex>

          <v-flex class="match-id">
            <v-text-field v-model="transferToMatchID"
                          :loading="transferToMatchIDLoading"
                          :append-icon="transferToMatch ? 'mdi-check' : ''"
                          label="Match ID"
                          placeholder="Match ID"></v-text-field>
            <p v-if="transferToMatch"><b>Match : </b>{{ transferToMatch.club1Alias.toUpperCase() }} - {{ transferToMatch.club2Alias.toUpperCase() }}</p>
          </v-flex>

          <p class="dialog-text error-message" v-if="getMatchError">{{ getMatchError }}</p>

          <div v-if="!transferToMatch">
            <p class="dialog-text">or</p>

            <div class="text-xs-center mb-3">
              <v-btn depressed="depressed" @click="openMatchCreate">Create a new match</v-btn>
            </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   flat="flat"
                   @click.native="cancelTransfer">Cancel</v-btn>
            <v-btn v-if="transferToMatch"
                   color="primary"
                   @click.native="transfer">Transfer</v-btn>
          </v-card-actions>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- CREATE MATCH FOR VIDEO TRANSFER -->
    <Dialog :dialog="createMatchToggled"
            :dialogState="'create'"
            :errorMessage="createMatchError"
            @dialogClosed="closeMatchCreate"
            @createMatch="createMatch"/>

    <!-- LOADER -->

    <LoadingPopup :displayed="createMatchLoading"
                  :title="'Creating match...'"
                  :text="'This operation may take a while\n\nPlease do not close this tab'"/>

  </div>

</template>

<script>

import ProxyDeleteButton from '../common/ProxyDeleteButton'
import ConfirmPopup from '../common/ConfirmPopup'
import Dialog from './Dialog'
import LoadingPopup from '../common/LoadingPopup'
import AuthorSelector from './AuthorSelector.vue'

export default {
  name: 'TableButtons',
  components: {
    ProxyDeleteButton,
    ConfirmPopup,
    Dialog,
    LoadingPopup,
    AuthorSelector
  },
  props: ['item', 'index'],
  data () {
    return {
      showMoreOptions: false,

      privatizationToggled: false,
      privatizationMatch: null,

      transferToggled: false,
      transferFromMatch: null,
      transferToMatch: null,
      transferToMatchID: null,
      transferToMatchIDLoading: false,
      authorsToTransfer: null,
      authorsToPrivatize: null,
      getMatchError: null,

      createMatchToggled: false,
      createMatchError: null,
      createMatchLoading: false
    }
  },
  methods: {
    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    toggleMenu () {
      this.showMoreOptions = !this.showMoreOptions
    },
    suspend (item) {
      this.$emit('suspend', item)
    },
    unsuspend (item) {
      this.$emit('unsuspend', item)
    },
    reprocess (item) {
      this.$emit('reprocess', item)
    },

    openTransfer (item) {
      this.$store.dispatch('getMatch', item.id)
        .then(resp => {
          this.transferFromMatch = resp
          this.transferToggled = true
        })
        .catch(() => {
          alert('No videos found on this match')
        })
    },
    cancelTransfer () {
      this.authorsToTransfer = null
      this.transferFromMatch = null
      this.transferToMatch = null
      this.transferToMatchID = null
      this.transferToMatchIDLoading = false
      this.transferToggled = false
      this.closeMatchCreate()
    },

    getTransferToMatch () {
      this.transferToMatch = null
      this.transferToMatchIDLoading = true
      this.$store.dispatch('getMatch', this.transferToMatchID)
        .then(resp => {
          this.transferToMatch = resp
          this.transferToMatchIDLoading = false
        })
        .catch(() => {
          this.transferToMatchID = ''
          this.transferToMatchIDLoading = false
        })
    },

    openMatchCreate () {
      this.createMatchToggled = true
    },
    closeMatchCreate () {
      this.createMatchToggled = false
    },
    createMatch (match) {
      if (this.checkFields(match)) {
        return
      }

      this.createMatchLoading = true
      this.$store.dispatch('createMatch', match)
        .then(resp => {
          this.transferToMatch = resp
          this.createMatchLoading = false
          this.transfer()
        })
        .catch(() => {
          this.createMatchLoading = false
          alert('Error creating match')
        })
    },

    checkFields (match) {
      if (!match.sportID) {
        this.createMatchError = 'Please select a sport'
        return true
      }

      if (!match.federationID) {
        this.createMatchError = 'Please select a federation'
        return true
      }

      if (!match.club1ID) {
        this.createMatchError = 'Please select club 1'
        return true
      }

      if (!match.club2ID) {
        this.createMatchError = 'Please select club 2'
        return true
      }

      if (!match.date) {
        this.createMatchError = 'Please enter a date'
        return true
      }

      return false
    },

    transfer () {
      const userIdToTransfer = this.authorsToTransfer.map(u => u.id)
      this.$emit('transfer', this.transferFromMatch, this.transferToMatch, userIdToTransfer)
    },

    openPrivatization (item) {
      this.privatizationMatch = item
      this.privatizationToggled = true
    },

    privatize () {
      const userIdToPrivatize = this.authorsToPrivatize.map(u => u.id)
      this.$emit('privatize', this.privatizationMatch, userIdToPrivatize)
    },

    cancelPrivatization () {
      this.privatizationMatch = null
      this.authorsToPrivatize = null
      this.privatizationToggled = false
    }
  },
  watch: {
    'transferToMatchID' () {
      if (
        this.transferToMatchID && this.transferToMatchID.length === 20) {
        if (this.transferToMatchID === this.transferFromMatch.id) {
          this.getMatchError = 'Please do not enter the same match'
          this.transferToMatch = null
          this.transferToMatchID = ''
        } else {
          this.getMatchError = null
          this.getTransferToMatch()
        }
      } else {
        this.transferToMatch = null
        this.transferToMatchID = ''
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .buttons-container {
    min-width: 180px;
    height: 48px;
    padding-top: 12px;
  }

  .button {
    width: 30px;
    height: 30px;
    display: inline-block;
  }

  .option {
    cursor: pointer;
    width: 100%;
    padding: 12px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 6px;
  }

  .option:hover {
    background-color: #cccccc;
  }

  .align-center {
    align-self: center;
  }

  .dialog-text {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
  }

  .error-message {
    color: red;
  }

  .match-id {
    max-width: 300px;
    margin: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/TableButtons.vue